import React from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import Icon from '../../../../../../../../components/icon/index';
import Button from '../../../../../../../../components/button/index';
import {
	autoCompleteEnteredValue,
	flash, getAddedCollaborators,
	getSharingDetailsPopup, isSharing, share
} from '../../../../../../../../../actions/sharingDetailsActions';
import {
	hasDuplicatedEmail,
	isEmailValid,
	isEmpty
} from '../../../../../../../../../actions/addCollaboratorActions';
import {labelStateUpdating, postCreateLabel} from '../../../../../../../../../actions/contactsGroupItemActions';
import ButtonWithIcon from "../../../../../../../../components/button-with-icon";
import './index.css';

class SharingButton extends React.Component {

	constructor(props) {
		super(props);

		this.share = this.share.bind(this);
	}

	share() {

		this.props.setIsSharing(true);

		try {
			const targetLabelId = (this.props.sharingDetailsPopup && this.props.sharingDetailsPopup[2])
				|| (this.props.selectOneLabelFromPopup && this.props.selectOneLabelFromPopup.id)
				|| (this.props.selectedContactsGroup && this.props.selectedContactsGroup.id);

			if (targetLabelId) {
				this.props.labelStateUpdating(targetLabelId);
			}

			const field = document.getElementById("addCollaboratorsField");
			const isFieldEmpty = !field || field.value.trim() === "";

			if (isFieldEmpty && this.props.addedCollaborators.length === 0) {
				this.props.setIsEmpty(true);
				this.props.setIsSharing(false);
			} else if (this.props.targetedContact && this.props.findLabels && this.props.findLabels.contactsGroups && this.props.findLabels.contactsGroups.length === 0) {

				/*
				* TargetedContact with no label
				* */

				this.props.postCreateLabel('🥳 My First Shared Group', true);

			} else {
				this.props.share();
			}
		} catch (err) {
			console.error("Error during share execution:", err);
			this.props.setIsSharing(false);
		}

	}

	render() {
		return (
			<div className={`share-button my-2 text-right position-relative`}>
				{
					this.props.isSharing
						?
						<Button className="btn-outline-secondary font-weight-bold" disabled={true}>
							<Icon animated={'pulse'} name="spinner"/>
						</Button>
						:
						<ButtonWithIcon onClick={this.share}
								disabled={this.props.profile === null || this.props.setGmailAddOnData === null || this.props.invalidShare}
								className="btn-outline-secondary">
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g>
									<path fill="#4CC2F1" d="M16,31C7.729,31,1,24.271,1,16C1,7.729,7.729,1,16,1c8.271,0,15,6.729,15,15C31,24.271,24.271,31,16,31z"/>
									<path fill="#FFFFFF" d="M16,2c7.72,0,14,6.28,14,14s-6.28,14-14,14S2,23.72,2,16S8.28,2,16,2 M16,0C7.164,0,0,7.164,0,16 c0,8.837,7.164,16,16,16c8.837,0,16-7.163,16-16C32,7.164,24.837,0,16,0L16,0z"/>
								</g>
								<g>
									<line fill="none" stroke="#FFFFFF" strokeMiterlimit="10" x1="12.519" y1="17.156" x2="17.48" y2="20.076"/>
									<line fill="none" stroke="#FFFFFF" strokeMiterlimit="10" x1="12.519" y1="14.843" x2="17.48" y2="11.924"/>
									<circle fill="#FFFFFF" cx="19.793" cy="10.708" r="2.677"/>
									<circle fill="#FFFFFF" cx="19.793" cy="21.292" r="2.677"/>
									<circle fill="#FFFFFF" cx="10.207" cy="16.061" r="2.677"/>
								</g>
							</svg>
							{this.props.t("btnGiveAccess")}
						</ButtonWithIcon>
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		findLabels: state.contactsGroupItemReducer.findLabels,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		autoComplete: state.sharingDetailsReducer.getAutoComplete,
		addedCollaborators: state.sharingDetailsReducer.getAddedCollaborators,
		invalidShare: state.sharingDetailsReducer.invalidShare,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		profile: state.profileReducer.getProfile,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
		isSyncing: state.syncStatusReducer.isSyncing,
		setGmailAddOnData: state.profileReducer.setGmailAddOnData,
		targetedContact: state.contactReducer.targetedContact,
		isSharing: state.sharingDetailsReducer.isSharing,
		selectOneLabelFromPopup: state.contactsGroupItemReducer.selectOneLabelFromPopup
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		autoCompleteEnteredValue: (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
		getAddedCollaborators: (array) => {
			dispatch(getAddedCollaborators(array))
		},
		setFlash: (array) => {
			dispatch(flash(array))
		},
		share: () => {
			dispatch(share())
		},
		setIsEmpty: (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid: (boolean) => {
			dispatch(isEmailValid(boolean))
		},
		setHasDuplicatedEmail: (boolean) => {
			dispatch(hasDuplicatedEmail(boolean))
		},
		postCreateLabel: (string, boolean) => {
			dispatch(postCreateLabel(string, boolean))
		},
		labelStateUpdating: (labelId) => {
			dispatch(labelStateUpdating(labelId))
		},
		setIsSharing: (boolean) => {
			dispatch(isSharing(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SharingButton));
